import Image from 'next/image'
import NextLink from 'next/link'
import { type FC } from 'react'
import { FormattedNumber } from 'react-intl'

import { type PimProductWithVariantsV1 } from '@redteclab/api/clients/bully'

import { useGlobalConfigContext } from '../../../global-config/context/globalConfigContext'
import { useCdnHostedImageLoader } from '../../../image/Loaders/cdnHostedImageLoader'
import { EXPERIMENT_TRACK_EVENT_OWN_BRANDS_OVERLAY_CLICK_ON_IMAGE } from '../../eventTracking/EXPERIMENTS_TRACK_EVENT'
import { experimentsTrackEvent } from '../../eventTracking/experimentsTrackEvent'
import { EXPERIMENT_VARIATION } from '../../model/EXPERIMENT_VARIATION'

import { useExperimentOwnBrandsOverlayProductProperties } from './useExperimentOwnBrandsOverlayProductProperties'

const IMAGE_SIZE_V1 = 130
const IMAGE_SIZE_V2 = 185

export const ExperimentOwnBrandsOverlayImage: FC<{
  discount: number
  product: PimProductWithVariantsV1
  variation: EXPERIMENT_VARIATION
}> = ({ discount, product, variation }) => {
  const globalConfig = useGlobalConfigContext()
  const { fallbackImageUrl, images, name, path, upid } =
    useExperimentOwnBrandsOverlayProductProperties(product)
  const loader = useCdnHostedImageLoader()

  const widthAndHeight =
    variation === EXPERIMENT_VARIATION.V1 ? IMAGE_SIZE_V1 : IMAGE_SIZE_V2

  return (
    <NextLink
      className="block px-3 tablet:px-3.5"
      data-qa-id={`form-product-slider-${upid}-image-button`}
      href={path}
      onClick={(): void => {
        experimentsTrackEvent(
          globalConfig,
          EXPERIMENT_TRACK_EVENT_OWN_BRANDS_OVERLAY_CLICK_ON_IMAGE,
        )
      }}
    >
      <div className="relative flex w-fit tablet:w-full tablet:items-center tablet:justify-center">
        <Image
          alt={name}
          data-analytics="item-image"
          height={widthAndHeight}
          loader={loader}
          src={images?.[0] ?? fallbackImageUrl}
          width={widthAndHeight}
        />
        {discount > 0 ? (
          <span className="absolute right-0 top-0 w-12 rounded-full bg-light-tertiary text-center font-mono text-xs leading-[48px]">
            <FormattedNumber style="percent" value={-discount / 100} />
          </span>
        ) : null}
      </div>
    </NextLink>
  )
}
